import { useState } from "react";
import { useForm } from "@mantine/form";
import NewButton from "../NewButton/NewButton";
import AppTextInput from "../AppTextInput/AppTextInput";
import styles from "./ExpertCallForm.module.css";
import { config } from "../../../utils/config";

export default function ExpertCallForm({ onSuccess, onError }) {
  const [loading, setLoading] = useState(false);
  const form = useForm({
    initialValues: {
      name: "",
      contact: "",
      organisation: "",
      designation: "",
    },

    validateInputOnChange: true,
    validateInputOnBlur: true,

    validate: {
      name: (v) => (!v ? "Please Provide Your Name" : null),
      contact: (v) => (!v ? "Please Provide Contact Number" : v.length !== 10 ? "Contact Number must be 10 digits" : null),
      organisation: (v) => (!v ? "Please Provide Organisation Name" : null),
    },
  });

  // 🔑 Override ONLY contact onChange
  const contactProps = form.getInputProps("contact");

  const handleContactKeyDown = (e) => {
    const key = e.key;
    const isDigit = /^\d$/.test(key);
    const isAllowed = isDigit || key === "Backspace" || key === "Tab" || key === "ArrowLeft" || key === "ArrowRight" || key === "Delete";
    if (!isAllowed && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
    }
  };

  const handleContactChange = (e) => {
    const sanitized = e.target.value.replace(/\D/g, "").slice(0, 10);
    contactProps.onChange({
      ...e,
      target: { ...e.target, value: sanitized },
    });
  };

  const handleSubmit = async (values) => {
    if (loading) return;
    if (!form.isValid()) return;
    setLoading(true);
    try {
      const message =
        `*New Expert Consultation Request*\n\n` +
        `*Name:* ${values.name}\n` +
        `*Contact Number:* ${values.contact}\n` +
        `*Organisation Name:* ${values.organisation}\n` +
        `*Designation:* ${values.designation || "N/A"}`;

      const response = await fetch(`${config.apiUrl}/api/send_slack/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          channel: config.channelName,
          message: message,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      onSuccess?.();
    } catch (error) {
      console.error("Error:", error);
      onError?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.paper}>
      <form className={styles.form} onSubmit={form.onSubmit(handleSubmit, () => onError?.())}>
        <div className={styles.header}>
          <h2 className={styles.title}>Fill Up this Form</h2>
          <p className={styles.subtitle}>Schedule your 1 - on - 1 Call with Our Experts</p>
        </div>

        <div className={styles.inputs}>
          <AppTextInput label="Your Name" required placeholder="Fill Your Name" {...form.getInputProps("name")} />
          <AppTextInput
            label="Contact Number"
            required
            placeholder="Enter Contact No."
            inputMode="numeric"
            {...contactProps}
            onChange={handleContactChange}
            onKeyDown={handleContactKeyDown}
          />
          <AppTextInput label="Organisation Name" required placeholder="Enter Organisation Name" {...form.getInputProps("organisation")} />
          <AppTextInput label="Designation" placeholder="Enter Your Designation" {...form.getInputProps("designation")} />
        </div>

        <NewButton type="submit" fullWidth disabled={!form.isValid()} loading={loading} className={styles.submitButton}>
          Submit Form
        </NewButton>
      </form>
    </div>
  );
}
